/**
 * Mutlak tarihin yanına konan GÖRELİ etiket — "2 yıl kaldı", "5 gün önce", "bugün".
 *
 * ### ⚠ Mutlak tarihin YERİNE geçmiyor, YANINA geliyor
 *
 * "5 gün kaldı" tek başına bir kayıt değil: kullanıcı sözleşmeyi bir takvime, bir dilekçeye
 * ya da bir hatırlatmaya işlerken günün kendisini yazıyor. Etiket yalnız ACİLİYETİ
 * okunabilir kılıyor; çağıranlar ikisini birlikte gösteriyor.
 *
 * ### ⚠ TAKVİM GÜNÜ sayılıyor, saat farkı değil
 *
 * Ham milisaniye farkıyla hesaplasaydık bugün 23:00'daki bir son tarih "13 saat", yarın
 * 01:00'daki bir tarih de "bugün" görünürdü. Kullanıcı son tarihi takvimden okuyor:
 * "yarın" demek "yarın", saat kaç olursa olsun. Bu yüzden iki uç da yerel gün başına
 * indirgeniyor.
 *
 * ### ⚠ AY ve YIL yaklaşık, ve bu bilinçli
 *
 * 30 ve 365 günlük kaba bölmeler kullanılıyor. Takvim ayı değişken (28–31) ve artık yıl
 * var; ama etiketin işi hesap yapmak değil, büyüklük sırasını söylemek. Kesin gün sayısı
 * gerektiğinde yanındaki mutlak tarih zaten orada. Daha doğru bir hesap, kullanıcının
 * göremeyeceği bir farkı düzeltmek için karmaşıklık eklerdi.
 */

const GUN_MS = 24 * 60 * 60 * 1000;

/** İki tarihin arasındaki TAKVİM GÜNÜ farkı; gelecek pozitif, geçmiş negatif. */
function gunFarki(hedef: Date, simdi: Date): number {
  const a = Date.UTC(hedef.getFullYear(), hedef.getMonth(), hedef.getDate());
  const b = Date.UTC(simdi.getFullYear(), simdi.getMonth(), simdi.getDate());
  return Math.round((a - b) / GUN_MS);
}

/**
 * @param iso ISO tarih dizesi; `null`/boş/okunamaz değerde etiket ÜRETİLMEZ.
 * @param simdi Karşılaştırma anı — testin sabitleyebilmesi için parametre.
 * @returns Türkçe etiket ya da `null`.
 */
export function relativeDateLabel(
  iso: string | null | undefined,
  simdi = new Date(),
): string | null {
  if (!iso) return null;
  const hedef = new Date(iso);
  /**
   * ⚠ Okunamayan değerde `null`. Uydurma bir etiket ("geçersiz tarih", "—") kullanıcıya
   * olmayan bir bilgi verirdi; yanındaki mutlak tarih zaten kendi hâlini gösteriyor.
   */
  if (Number.isNaN(hedef.getTime())) return null;

  const fark = gunFarki(hedef, simdi);
  const gelecek = fark > 0;
  const mutlak = Math.abs(fark);

  if (mutlak === 0) return "bugün";
  if (mutlak === 1) return gelecek ? "yarın" : "dün";

  const ek = gelecek ? "kaldı" : "önce";
  if (mutlak < 30) return `${mutlak} gün ${ek}`;
  if (mutlak < 365) return `${Math.round(mutlak / 30)} ay ${ek}`;
  return `${Math.floor(mutlak / 365)} yıl ${ek}`;
}
